import BaseEvent from './BaseEvent.js';
import { getOSM } from '../../OverworldAnimation.js';
import { LEFT, UP, DOWN, RIGHT } from '../../constants.js';
import OverworldAction from '../OverworldAction.js';
import Pokemon from '../Pokemon.js';

export default class RivalBattle1 extends BaseEvent {
    constructor({
        identifier = 'rival_battle_1',
        isActive = true,
        complete = false,
        autoComplete = false,
        objectsIdentifiers = ['route_1_rival', 'route_1_pokemon_professor', 'scientist_1'],
    } = {}) {
        super({ identifier, isActive, complete, autoComplete, objectsIdentifiers });
        this.route1Rival = null;
        this.route1PokemonProfessor = null;
    }

    static deserialize(data) {
        return new RivalBattle1({
            isActive: data.isActive,
            complete: data.complete,
        });
    }

    executeActions() {
        const osm = getOSM();
        const player = osm.player;
        const route1Rival = this.getObject('route_1_rival');
        const route1PokemonProfessor = this.getObject('route_1_pokemon_professor');
        const scientist1 = this.getObject('scientist_1');
        osm.readText('Hey you!', { speaker: '???' });
        osm.finishReading();
        osm.script(() => {
            osm.context.npcSeenBy = route1Rival;
        });
        const rivalFacePlayerTile = {
            x: player.position.x + 16,
            y: player.position.y,
            z: player.position.z,
        };
        osm.moveNPCV2(route1Rival, rivalFacePlayerTile);
        osm.script(() => {
            route1Rival.direction = LEFT;
        });

        osm.script(async () => {
            const rivalNidoran1 = await Pokemon.create({
                id: player.gender === 'boy' ? 32 : 29,
                level: 1,
                iv: {
                    hp: 0,
                    attack: 31,
                    defense: 0,
                    specialAttack: 31,
                    specialDefense: 31,
                    speed: 0,
                },
            });
            route1Rival.party[0] = rivalNidoran1;
        });
        osm.readText("I just got a brand new Pokémon! Let's battle!", { speaker: '???' });
        osm.finishReading();
        osm.darkenScreen();
        if (!osm.shouldSkipOverworldEvents()) {
            osm.activateBattle({ skipEndBattle: true });
            osm.actions.push(
                new OverworldAction({
                    action: () => {
                        return !osm.context.inBattle;
                    },
                })
            );
        }
        osm.undarkenScreen();
        osm.script(() => {
            osm.context.npcSeenBy = null;
        });
        if (!osm.shouldSkipOverworldEvents()) {
            osm.readText("Wow you're actually pretty good!", { speaker: 'Rumbi' });
            osm.continueReading();
            osm.readText('That was actually my first battle ever though.');
            osm.finishReading();
            osm.script(() => {
                route1Rival.direction = RIGHT;
                route1Rival.showExclamationMark();
            });
            osm.delay(30);
            osm.readText('Hold it right there!', { speaker: '???' });
            osm.finishReading();
            osm.delay(30);
        }
        osm.moveNPCV2(route1PokemonProfessor, {
            x: player.position.x + 32,
            y: player.position.y,
            z: 0,
        })

        const verticalStep = player.position.y < route1PokemonProfessor.position.y ? DOWN : UP;
        const targetRivalTile = {
            x: player.position.x,
            y: player.position.y + (verticalStep === DOWN ? 16 : -16),
            z: player.position.z,
        };
        osm.moveNPCV2(route1Rival, targetRivalTile);
        if (!osm.shouldSkipOverworldEvents()) {
            osm.script(() => (route1Rival.direction = RIGHT));
            osm.delay(40);
            osm.readText('That was some battle!', { speaker: '???' });
            osm.continueReading();
            osm.readText("I've got to say, I'm quite impressed with both of you.");
            osm.continueReading();
            osm.readText('Both of us... really...?', { speaker: 'Rumbi' });
            osm.continueReading();
            osm.readText('Yes! It seemed pretty close from where I was standing.', { speaker: '???' });
            osm.continueReading();
            osm.readText('Well... if you say so...', { speaker: 'Rumbi' });
            osm.continueReading();
            osm.readText(() => `I'm ${route1Rival.name} by the way!`);
            osm.continueReading();
            osm.readText(() => `and this is uh...`, { speaker: () => route1Rival.name });
            osm.continueReading();
            osm.readText('... ... ... ... ...');
            osm.continueReading();
            osm.script(() => {
                route1Rival.direction = player.position.y > route1Rival.position.y ? DOWN : UP;
                player.direction = route1Rival.direction === DOWN ? UP : DOWN;
            });
            osm.readText(() => `I guess I never asked you your name!`);
            osm.continueReading();
            osm.readText(() => `we got right to battling as soon as we met!`);
            osm.continueReading();
            osm.readText(() => `oh so you're ${player.name}. Cool!`);
            osm.finishReading();
            osm.script(() => {
                route1Rival.direction = RIGHT;
                player.direction = RIGHT;
            });
            osm.script(() => {
                route1PokemonProfessor.showExclamationMark();
            });
            osm.delay(30);
            osm.readText(
                `How embarrassing, I was so caught up with your battling that I forgot to introduce myself!`,
                { speaker: '???' }
            );
            osm.continueReading();
            osm.readText(() => `I am ${route1PokemonProfessor.name}.`);
            osm.continueReading();

            osm.readText(
                () => `I've been looking for talented trainers to help me gather Pokemon data.`,
                { speaker: () => route1PokemonProfessor.name }
            );
            osm.continueReading();
            osm.readText(() => `The Borikén Region is full of Pokémon, most of which are not native!`);
            osm.continueReading();
            osm.readText(() => `I suspect many tagged along with colonizers many years ago...`);
            osm.continueReading();
            osm.readText(() => `But I'll need more data to confirm that hypothesis.`);
            osm.continueReading();
            osm.readText(() => `Well, I'll be grabbing a bite in my Lab over in Bramblecrest.`);
            osm.continueReading();
            osm.readText(() => `Feel free to stop by if you want to hear more about my project!`);
            osm.finishReading();
            osm.moveNPCV2(route1PokemonProfessor, {
                x: 1344,
                y: 368,
                z: 0,
            });
            osm.script(() => {
                player.direction = LEFT;
                route1Rival.direction = LEFT;
            });
            osm.script(() => {
                route1PokemonProfessor.showExclamationMark();
            });
            osm.delay(30);
            osm.script(() => {
                route1PokemonProfessor.direction = UP;
            });
            osm.delay(10);
            osm.script(() => {
                route1PokemonProfessor.direction = DOWN;
            });
            osm.delay(60);
            osm.readText(() => `Oh no...`, { speaker: () => route1PokemonProfessor.name });
            osm.continueReading();
            osm.readText(() => `I can't believe I left my Lunch Box behind!`);
            osm.finishReading();
            const targetProfessorTile = {
                x: player.position.x - 16,
                y: player.position.y,
                z: player.position.z,
            };
            osm.moveNPCV2(route1PokemonProfessor, targetProfessorTile);
            osm.readText(() => `I'm a bit embarrased to ask you for this favor, ${player.name}...`, {
                speaker: () => route1PokemonProfessor.name,
            });
            osm.continueReading();
            osm.readText(
                () => `But could head over to Vine Cave, find my Lunch Box, and bring it to my Lab?`
            );
            osm.continueReading();
            osm.readText(() => `I promise I'll make it worth your while.`);
            osm.continueReading();
            osm.readText(() => `The entrance to Vine Cave is in Route 2, east of Mistral Heights.`);
            osm.continueReading();
            osm.readText(() => `But first, I suggest you stop by the Pokémon Center across the bridge.`);
            osm.continueReading();
            osm.readText(() => `In the meantime, ${route1Rival.name}, I can heal your Pokémon in my Lab.`);
            osm.continueReading();
            osm.readText(() => `Come with me!`);
            osm.continueReading();
            osm.readText(() => `Thanks Professor!`, { speaker: () => route1Rival.name });
            osm.finishReading();
        }



        osm.actions.push(
            osm.parallel(
                osm.createMoveNPCV2Action(route1PokemonProfessor, { x: 1344, y: 368, z: 0 }, { facingDirection: LEFT }),
                osm.createMoveNPCV2Action(route1Rival, { x: 1344 + 16, y: 368, z: 0 }, { facingDirection: LEFT }),
            )
        )

        osm.actions.push(
            osm.parallel(
                osm.createMoveNPCV2Action(route1PokemonProfessor, { x: 1248, y: 368, z: route1PokemonProfessor.z }, { skipCollisions: true }),
                osm.createMoveNPCV2Action(route1Rival, { x: 1248 + 16, y: 368, z: route1PokemonProfessor.z }, { skipCollisions: true }),
            )
        );

        osm.script(() => {
            osm.currentMap.getObjectByIdentifier('dont_forget_lunchbox_0').getEvent().isActive = true;
            osm.currentMap.getObjectByIdentifier('dont_forget_lunchbox_1').getEvent().isActive = true;
            osm.currentMap.getObjectByIdentifier('dont_forget_lunchbox_2').getEvent().isActive = true;
            route1PokemonProfessor.visible = false;
            route1PokemonProfessor.position.z = 7;
            route1Rival.visible = false;
            route1Rival.position.z = 7;
            scientist1.position.x -= 16;
            scientist1.useFresh = false;
            scientist1.text = 'Professor Abu is back!';
            this.complete = true;
        });
    }
}
